import React from 'react';
import styled from 'styled-components';
import merchantIcon from '../../Assets/TreePlanting/MerchantIcon.png';
import commissionIcon from '../../Assets/TreePlanting/CommissionIcon.png';
import treeIcon from '../../Assets/TreePlanting/TreeIcon.png';
import { mobileMediaQuery, themeColor } from '../../Theming';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  width: 100%;
  height: 614px;
  display: block;
  text-align: center;
  justify-content: center;
  align-items: center;
  background-color: ${themeColor('forestGreen')};
  margin-top: 50px;

  ${mobileMediaQuery} {
    width: 100%;
    height: auto;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  text-align: center;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 100px;

  ${mobileMediaQuery} {
    display: block;
    justify-content: center;
    width: 100%;
    height: auto;
    margin-top: 50px;
  }
`;

const InnerContentContainer = styled.div`
  width: 280px;
  height: 300px;
  display: block;
  text-align: center;

  ${mobileMediaQuery} {
    width: 100%;
    margin-bottom: 40px;
    margin-top: 0px;
    justify-content: center;
    align-items: center;
  }
`;

const IconsContainer = styled.div`
  width: 221px;
  height: 221px;
  background-color: ${themeColor('white')};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 30px auto;

  ${mobileMediaQuery} {
    width: 174px;
    height: 174px;
  }
`;

const HeaderText = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 45px;
  line-height: 54px;
  text-align: center;
  margin-top: 60px;
  color: ${themeColor('white')};

  ${mobileMediaQuery} {
    font-size: 28px;
    line-height: 34px;
    margin-top: 40px;
  }
`;

const Description = styled.p`
  font-weight: 400;
  font-size: 17px;
  line-height: 20px;
  color: ${themeColor('white')};

  ${mobileMediaQuery} {
    width: 280px;
    text-align: center;
    font-size: 15px;
    line-height: 18px;
    align-self: center;
    margin: 0 auto 30px auto;
  }
`;

const Icon = styled.img`
  max-width: 190px;
  max-height: 130px;

  ${mobileMediaQuery} {
    max-width: 180px;
    max-height: 120px;
  }
`;

const HowDoesItWork: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <HeaderText>{t('treePlanting.howDoesItWork.heading')}</HeaderText>
      <ContentContainer>
        <InnerContentContainer>
          <IconsContainer>
            <Icon src={merchantIcon} />
          </IconsContainer>
          <Description>
            {t('treePlanting.howDoesItWork.descriptions.part1')}
          </Description>
        </InnerContentContainer>
        <InnerContentContainer>
          <IconsContainer>
            <Icon src={commissionIcon} />
          </IconsContainer>
          <Description>
            {t('treePlanting.howDoesItWork.descriptions.part2')}
          </Description>
        </InnerContentContainer>
        <InnerContentContainer>
          <IconsContainer>
            <Icon src={treeIcon} />
          </IconsContainer>
          <Description>
            {t('treePlanting.howDoesItWork.descriptions.part3')}
          </Description>
        </InnerContentContainer>
      </ContentContainer>
    </Container>
  );
};

export default HowDoesItWork;
